import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { getOrganizationVatDeclarationPeriods } from '../query-api'
import { VatDeclarationPeriods } from '../types/vatDeclarationPeriods'

interface UseVatDeclarationPeriodsProps {
  isLoading: boolean
  vatDeclarationPeriods: VatDeclarationPeriods
}

export const useVatDeclarationPeriods = (): UseVatDeclarationPeriodsProps => {
  const { organization } = useUserOrganization()
  const { data: vatDeclarationPeriodsData, isLoading } = useQuery(
    [QueryKeys.VatDeclarationPeriods, organization?.id],
    () => getOrganizationVatDeclarationPeriods(organization?.id || ''),
    {
      enabled: !!organization?.id,
    },
  )

  return {
    isLoading,
    vatDeclarationPeriods: vatDeclarationPeriodsData?.periods || {},
  }
}
